export default "__VITE_ASSET__ByJ64ZND__"